module.exports = __webpack_public_path__ + "static/media/yes.0d79d1a7.mp3";